import { create } from "apisauce";
import Utils from "../Utils";

const BASE_URL = "";
const api = create({ baseURL: BASE_URL });
const checkURL=(url)=>{
	const lastChar = url?.charAt(url?.length - 1);
	if(lastChar === '/')
	return url;
	else return `${url}/`;
}

api.axiosInstance.interceptors.request.use(async (config) => {
	config.headers.email=window?.authProvider?.account?.userName
	if (window.access_token) {
		console.log("Found access token");
		config.headers.Authorization = `Bearer ${window.access_token}`;
	} else if (window.id_token) {
		console.log("Found id token");
		config.headers.Authorization = `Bearer ${window.id_token}`;
	} else if (window.authProvider) {
		console.log("Trying to get access token using provider");
		const token = await window.authProvider.getAccessToken();
		console.log(token.accessToken);
		config.headers.Authorization = `Bearer ${token.accessToken}`;
	}
	return config;
});

function processResponse(response, method, uri) {
	return new Promise((resolve, reject) => {
		if (response.status >= 200 && response.status < 400) {
			Utils.isJsonString(response.data)
				? resolve(JSON.parse(response.data))
				: resolve(response.data);
		} else if (response.status === 401) {
			reject({ message: "You are unauthenticated, please log in again" });
		} else {
			console.error(
				`HTTP ${method} call to ${uri} failed with response code ${response.status}`
			);
			reject({ message: response.data });
		}
	});
}
export const ChateauxAPI = {
	async getPriceDigestConfig(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PENTON_URL)}pricedigests/config`;
		const response = await api.post(path, requestBody);
		return processResponse(response, "post", path);
	},
	async getPriceDigestValue(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PENTON_URL)}pricedigests/value`;
		const response = await api.post(path, requestBody);
		return processResponse(response, "post", path);
	},
	async getEquipmentWatchConfig(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PENTON_URL)}equipmentwatch/config`;
		const response = await api.post(path, requestBody);
		return processResponse(response, "post", path);
	},
	async getEquipmentWatchValue(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PENTON_URL)}equipmentwatch/value`;
		const response = await api.post(path, requestBody);
		return processResponse(response, "post", path);
	},
	async calculateTValue(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_TVALUE_URL)}CalculateTvalueFunction`;
		const response = await api.post(path, requestBody);
		return processResponse(response, "post", path);
	},
	async getTLOPersonSearch(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_TLO_URL)}person-search`;
		const response = await api.post(path, requestBody);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
	async getTLOLocateReport(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_TLO_URL)}locate-report`;
		const response = await api.post(path, requestBody);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
	async getTLOCriminalSearch(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_TLO_URL)}criminal-search`;
		const response = await api.post(path, requestBody);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
	async getTLOUCCSearch(requestBody) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_TLO_URL)}ucc-search`;
		const response = await api.post(path, requestBody);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
	async getCompanies(data) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PAYNET_URL)}direct/CompanySearch`;
		const response = await api.post(path, data);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
	async getReport(data) {
		const path = `${BASE_URL}${checkURL(process.env.REACT_APP_PAYNET_URL)}direct/GetReport`;
		const response = await api.post(path, data);
		if (response.status === 404) return [];
		return processResponse(response, "post", path);
	},
}
